import styled from 'styled-components';

const DropdownItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 4px 12px;
  cursor: pointer;
  z-index: 1000;

  &:hover {
    background-color: #cccccc80;
  }
`;

export default DropdownItem;
